module.exports = "https://web-phone.apps.phone.com/static/media/dtmf-8.48300a56.mp3";